@if (visible) {
  <div class="alert-container" [ngClass]="type">
    <div class="alert-content" style="display:flex;align-items:center;gap:8px;">
      <mat-icon class="alert-icon">
        {{
        type === 'success' ? 'check_circle' :
        type === 'error' ? 'error' :
        type === 'warning' ? 'warning' : 'info'
        }}
      </mat-icon>
      <span class="alert-message">{{ message }}</span>
      <div class="alert-actions" style="margin-left:auto;">
        <button mat-icon-button (click)="showHelp()" matTooltip="Ayuda" aria-label="Ayuda">
          <mat-icon>help_outline</mat-icon>
        </button>
      </div>
    </div>
  </div>
}
